document.documentElement.classList.remove('no-js');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
const currency = document.body?.dataset.currency || 'GBP';
const money = (cents) => new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(Number(cents || 0) / 100);

function openDrawer(element) {
  if (!element) return;
  element.classList.add('is-open');
  element.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
}

function closeDrawer(element) {
  if (!element) return;
  element.classList.remove('is-open');
  element.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
}

const mobileMenu = $('[data-mobile-menu]');
$('[data-mobile-menu-open]')?.addEventListener('click', (event) => {
  openDrawer(mobileMenu);
  event.currentTarget.setAttribute('aria-expanded', 'true');
});
$('[data-mobile-menu-close]')?.addEventListener('click', () => {
  closeDrawer(mobileMenu);
  $('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
});

const searchDrawer = $('[data-search-drawer]');
$('[data-search-open]')?.addEventListener('click', (event) => {
  searchDrawer?.showModal();
  event.currentTarget.setAttribute('aria-expanded', 'true');
  setTimeout(() => $('[data-predictive-search-input]')?.focus(), 50);
});
$('[data-search-close]')?.addEventListener('click', () => {
  searchDrawer?.close();
  $('[data-search-open]')?.setAttribute('aria-expanded', 'false');
});
searchDrawer?.addEventListener('click', (event) => {
  if (event.target === searchDrawer) searchDrawer.close();
});

let searchTimer;
$('[data-predictive-search-input]')?.addEventListener('input', (event) => {
  clearTimeout(searchTimer);
  const query = event.target.value.trim();
  const target = $('[data-predictive-results]');
  if (query.length < 2) {
    if (target) target.innerHTML = '';
    return;
  }
  searchTimer = setTimeout(async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      if (!target) return;
      target.innerHTML = products.length
        ? `<div class="predictive-grid">${products.map((product) => `
          <a href="${product.url}" class="predictive-item">
            ${product.image ? `<img src="${product.image}" alt="">` : ''}
            <span><small>${product.vendor || 'Fancy Fashions'}</small><strong>${product.title}</strong><em>${product.price}</em></span>
          </a>`).join('')}</div><a class="text-link" href="${root}search?q=${encodeURIComponent(query)}">View all results ↗</a>`
        : '<p class="empty-state">No matching pieces found.</p>';
    } catch (error) {
      if (target) target.innerHTML = '<p class="empty-state">Search is temporarily unavailable.</p>';
    }
  }, 250);
});

class QuantityInput extends HTMLElement {
  connectedCallback() {
    const input = $('input', this);
    $$('button', this).forEach((button) => button.addEventListener('click', () => {
      const step = button.name === 'plus' ? 1 : -1;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

function showToast(message) {
  const toast = $('[data-cart-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  toast.classList.add('is-visible');
  setTimeout(() => { toast.classList.remove('is-visible'); toast.hidden = true; }, 2800);
}

async function addToCart(form) {
  const section = form.closest('[data-product-section]');
  const buttons = section ? $$('[data-add-to-cart], [data-add-to-cart-mobile]', section) : [$('button[type="submit"]', form)].filter(Boolean);
  const originals = buttons.map((button) => button.innerHTML);
  buttons.forEach((button) => { button.disabled = true; button.textContent = 'Adding…'; });
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw await response.json();
    await response.json();
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    showToast('Added to your bag');
  } catch (error) {
    const errorTarget = $('[data-product-form-errors]', form.parentElement) || $('[data-product-form-errors]');
    if (errorTarget) errorTarget.textContent = error.description || 'This piece could not be added. Please try again.';
    else showToast(error.description || 'Unable to add this piece.');
  } finally {
    buttons.forEach((button, index) => { button.disabled = false; button.innerHTML = originals[index]; });
  }
}

$$('[data-quick-add]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addToCart(form); }));

$$('[data-product-section]').forEach((section) => {
  const variants = JSON.parse($('[data-variant-json]', section)?.textContent || '[]');
  const selects = $$('[data-option-select]', section);
  const optionButtons = $$('[data-option-button]', section);
  const form = $('[data-product-form]', section);
  const variantInput = $('[data-variant-id]', section);
  const addButtons = $$('[data-add-to-cart], [data-add-to-cart-mobile]', section);
  const addTexts = $$('[data-add-to-cart-text]', section);
  const addPrices = $$('[data-add-to-cart-price]', section);
  const availability = $('[data-availability]', section);
  const price = $('[data-product-price]', section);
  const compare = $('[data-compare-price]', section);
  const mobilePrice = $('[data-mobile-price]', section);
  const mobileVariant = $('[data-mobile-variant]', section);

  const selectVariant = () => {
    const selected = selects.map((select) => select.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) {
      addButtons.forEach((button) => { button.disabled = true; });
      addTexts.forEach((text) => { text.textContent = 'Unavailable'; });
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
    if (mobilePrice) mobilePrice.textContent = money(variant.price);
    if (mobileVariant) mobileVariant.textContent = variant.title;
    addPrices.forEach((node) => { node.textContent = money(variant.price); });
    addButtons.forEach((button) => { button.disabled = !variant.available; });
    addTexts.forEach((text) => { text.textContent = variant.available ? 'Add to bag' : 'Sold out'; });
    if (availability) availability.innerHTML = variant.available ? '<span></span> In stock and ready to dispatch' : 'Currently unavailable';
    optionButtons.forEach((button) => {
      const selectedValue = selected[Number(button.dataset.optionIndex)];
      const isSelected = button.dataset.optionValue === selectedValue;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });
    if (variant.featured_media?.id) $(`[data-media-target="${variant.featured_media.id}"]`, section)?.click();
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };
  selects.forEach((select) => select.addEventListener('change', selectVariant));
  optionButtons.forEach((button) => button.addEventListener('click', () => {
    const select = selects[Number(button.dataset.optionIndex)];
    if (!select) return;
    select.value = button.dataset.optionValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  form?.addEventListener('submit', (event) => { event.preventDefault(); addToCart(form); });

  $$('[data-media-target]', section).forEach((button) => button.addEventListener('click', () => {
    $$('[data-media-id]', section).forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
    $$('[data-media-target]', section).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }));

  const sizeModal = $('[data-size-guide-modal]', section);
  const hydrateProductSizeGuide = () => {
    const target = $('[data-size-guide-product-content]', sizeModal);
    if (!target || target.dataset.hydrated === 'true') return;
    target.dataset.hydrated = 'true';

    const descriptionImages = $$('.product-accordions--editorial .rte img', section);
    const galleryImages = $$('[data-product-gallery] img', section);
    const images = [...descriptionImages, ...galleryImages];
    const chartPattern = /(size[\s_-]*(chart|guide)|measurement[\s_-]*(chart|guide)?)/i;
    let chartImage = images.find((image) => chartPattern.test(`${image.alt || ''} ${image.currentSrc || image.src || ''}`));
    if (!chartImage && descriptionImages.length === 1) chartImage = descriptionImages[0];
    if (!chartImage) return;

    const clone = chartImage.cloneNode(false);
    clone.loading = 'eager';
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    clone.alt = clone.alt || `Size chart for ${document.querySelector('h1')?.textContent?.trim() || 'this product'}`;
    target.replaceChildren(clone);
    target.hidden = false;
    $('[data-size-guide-theme-fallback]', sizeModal)?.setAttribute('hidden', '');
  };
  $$('[data-size-guide-open]', section).forEach((button) => button.addEventListener('click', () => {
    if (!sizeModal) return;
    hydrateProductSizeGuide();
    if (typeof sizeModal.showModal === 'function') sizeModal.showModal();
    else sizeModal.setAttribute('open', '');
  }));
  $('[data-size-guide-close]', section)?.addEventListener('click', () => {
    if (typeof sizeModal?.close === 'function') sizeModal.close();
    else sizeModal?.removeAttribute('open');
  });
  sizeModal?.addEventListener('click', (event) => {
    if (event.target !== sizeModal) return;
    if (typeof sizeModal.close === 'function') sizeModal.close();
    else sizeModal.removeAttribute('open');
  });

  const lightbox = $('[data-product-lightbox]', section);
  const lightboxSlides = $$('[data-product-lightbox-slide]', section);
  const lightboxCounter = $('[data-product-lightbox-counter]', section);
  let activeLightboxSlide = 0;
  const showLightboxSlide = (index) => {
    if (!lightboxSlides.length) return;
    activeLightboxSlide = (index + lightboxSlides.length) % lightboxSlides.length;
    lightboxSlides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== activeLightboxSlide; });
    if (lightboxCounter) lightboxCounter.textContent = `${activeLightboxSlide + 1} / ${lightboxSlides.length}`;
  };
  $$('[data-product-lightbox-open]', section).forEach((button) => button.addEventListener('click', () => {
    showLightboxSlide(Number(button.dataset.productLightboxOpen));
    lightbox?.showModal();
  }));
  $('[data-product-lightbox-close]', section)?.addEventListener('click', () => lightbox?.close());
  $('[data-product-lightbox-previous]', section)?.addEventListener('click', () => showLightboxSlide(activeLightboxSlide - 1));
  $('[data-product-lightbox-next]', section)?.addEventListener('click', () => showLightboxSlide(activeLightboxSlide + 1));
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
  lightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showLightboxSlide(activeLightboxSlide - 1);
    if (event.key === 'ArrowRight') showLightboxSlide(activeLightboxSlide + 1);
  });
});

$$('product-recommendations').forEach(async (element) => {
  if (!element.dataset.url) return;
  const html = await fetch(element.dataset.url).then((response) => response.text()).catch(() => '');
  if (!html) return;
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const replacement = parsed.querySelector('product-recommendations');
  if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
});

const filterDrawer = $('[data-filter-drawer]');
$('[data-filter-open]')?.addEventListener('click', () => openDrawer(filterDrawer));
$('[data-filter-close]')?.addEventListener('click', () => closeDrawer(filterDrawer));
$('[data-sort-select]')?.addEventListener('change', (event) => event.target.form?.submit());
